module.exports = new __parcel__URL__("dodo.a7114237.svg").toString();